export default "__VITE_ASSET__Dbvt1nsn__"